let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1JgW0")).then(() => parcelRequire('6Tbkh'));